import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import { ResponseGetAutoLogin } from "./autoLoginInterface";

class AutoLoginApi {
  private baseUrl: string;

  private pathCorporate: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.pathCorporate = "v2/corporate/personalTrip";
  }
  // ******************************************************
  // ****************** Method: GET ***********************
  // ******************************************************

  async getTokenPersonalTrip(param: { token: string }) {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.pathCorporate}/autoLogin?token=${param.token}`,
      "GET",
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      false,
    )) as any;

    return new ResponseGetAutoLogin(response);
  }

  // ******************************************************
  // ****************** Method: POST ***********************
  // ******************************************************
}
export default AutoLoginApi;
